export default __webpack_public_path__ + "static/media/vivek prasad.34c974e3.jpg";